import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../style.css';

function Quickinfo() {
  return (
    <div className="container-fluid scroll-target">
        <div className="row align-items-center">
          {/* Text Section */}
          <div className="col-md-6 text-center text-md-start order-2 order-md-1  animate-fade-in-left">
            <h1 className="fw-bold mb-3">About Us</h1>
            <p className="fw-bold">
            Bespoke Inc. is a team of experienced Engineering Consultants with over 15 years in the automotive industry, specializing in vehicle homologation and certification services.

We have successfully secured certification across a wide range of vehicle categories — from passenger cars and light commercial vehicles to motorcycles, motorhomes, and specialist vehicles.

Currently, Bespoke Inc. is contracted to oversee homologation processes for several major Registered Automotive Workshops in Australia. We have achieved ADR certification for a variety of vehicles, including passenger cars, light vehicles, and motorcycles.

In response to the growing demand for motorcycle imports, our focus has shifted to key models such as the Harley Davidson Sportster, Softail, Dyna, Indian Scout, and Bourget Python.
            </p>
            
          </div>
          </div>
          </div>
  );
}

export default Quickinfo;